// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__ZphPe","noSpacingTop":"Main_noSpacingTop__XHu1C","noSpacingBottom":"Main_noSpacingBottom__1dRba"};